// validationSchema.js
import * as yup from "yup";

export const Rolechema = yup.object().shape({
  // name: yup.string().required("Role Name is required"),
});
